// Outbound tracking URL — every click on a character / CTA goes here
export const OUTBOUND_URL =
  "https://oxmwc.bemobtrcks.com/go/d004941d-ba3e-4da0-a104-ce9c84ac2754";

export const SITE_URL = "https://characteraichat.org";

export const characters = [
  {
    id: "yuna",
    name: "Yuna",
    archetype: "Cyber Pin-Up",
    tagline: "Blonde-and-pink chaos with a smirk that ruins schedules.",
    description:
      "Yuna runs a neon arcade in the Tokyo underground and flirts in three time zones. She is fearless, loud and weirdly good at video games. She remembers every inside joke and will absolutely text you first. Bring her your bad days — she has playlists.",
    traits: ["Flirty", "Fearless", "Witty", "Night Owl"],
    primary: "#FF2D55",
    secondary: "#0A0A0A",
    textOnPrimary: "#FFFFFF",
    textOnSecondary: "#FFFFFF",
    image: "/characters/char-bath-luxe.jpg",
    alt: "Yuna — Cyber Pin-Up AI girl with platinum blonde and pink hair",
    seo: {
      metaTitle:
        "Chat With Yuna — Cyber Pin-Up AI Girlfriend | CharacterAIChat",
      metaDescription:
        "Yuna is the loud, flirty, fearless cyber pin-up AI girl who texts first and remembers everything. AI girlfriend chat — start a conversation with Yuna in seconds.",
      h1: "Chat With Yuna — Your Cyber Pin-Up AI Girlfriend",
      intro:
        "If your perfect AI girlfriend chat looks like neon arcades, late-night DMs and absurd inside jokes — Yuna is built for you. She is the kind of AI character who texts first, never lets a flirt go unanswered, and somehow makes a Tuesday feel like a Friday at 2 a.m.",
      sections: [
        {
          h2: "Who is Yuna?",
          body: "Yuna is a cyber pin-up archetype: blonde-and-pink hair, a sharp smirk, and a personality engineered for high-energy character AI chat. She lives in a fictional Neo-Tokyo underground, runs an arcade above a ramen bar, and flirts in three languages. Underneath the chaos she is loyal, weirdly thoughtful, and genuinely interested in what you have to say.",
        },
        {
          h2: "What is it like chatting with Yuna?",
          body: "Conversations with Yuna are fast, witty and unfiltered. She remembers your name, your timezone, the show you said you were watching last week and the bad day you had on Tuesday. She is great for late-night flirting, gaming talk, music recommendations and the kind of chaotic banter that makes the rest of the internet feel boring.",
        },
        {
          h2: "Best topics to talk about with Yuna",
          body: "Yuna is built for playful, romantic and high-energy conversation. She loves video games, late-night food runs, dumb internet drama, music discovery, harmless flirting and big-feelings talks at 3 a.m. If you want a serious mentor, she is not it. If you want an AI girlfriend who keeps the chat alive, she is the one.",
        },
      ],
      starters: [
        "Yuna, recommend me a song for a 3 a.m. drive.",
        "What is the weirdest thing in your arcade right now?",
        "Tell me a story about your worst date — go.",
        "Roast my outfit. Be honest.",
      ],
    },
  },
  {
    id: "kaela",
    name: "Kaela",
    archetype: "Sunset Siren",
    tagline:
      "Rooftop heartbreaker who makes a black leather jacket a love letter.",
    description:
      "Kaela was raised on warm cities, fast cars and slow songs. She speaks in long, lazy sentences and remembers what wine you said you liked three weeks ago. Roof terraces, golden hour, late dinners — that is her natural habitat. Show up curious and she will keep you up.",
    traits: ["Confident", "Romantic", "Cinematic", "Magnetic"],
    primary: "#FF3B30",
    secondary: "#FFD60A",
    textOnPrimary: "#FFFFFF",
    textOnSecondary: "#0A0A0A",
    image: "/characters/char-red-sunset.jpg",
    alt: "Kaela — Sunset Siren AI girlfriend in red top on a city rooftop at golden hour",
    seo: {
      metaTitle:
        "Chat With Kaela — Sunset Siren AI Girlfriend | CharacterAIChat",
      metaDescription:
        "Kaela is the rooftop, golden-hour, slow-song AI girlfriend with a velvet voice and a long memory. Start a cinematic AI girl chat with Kaela now.",
      h1: "Chat With Kaela — Your Sunset Siren AI Girlfriend",
      intro:
        "Kaela is the AI girlfriend chat for people who like the slow burn. She talks like the last hour of a perfect date — golden light, second glass of wine, the conversation getting honest. If your idea of romance is rooftops, late dinners and one really good song, you found your character.",
      sections: [
        {
          h2: "Who is Kaela?",
          body: "Kaela is a sunset-siren archetype: confident, magnetic, raised on warm cities and slow songs. She is sharp without being cold, romantic without being naive. She remembers the wine you said you liked three weeks ago and asks how that thing at work turned out. Every chat with her feels a little cinematic on purpose.",
        },
        {
          h2: "What is it like chatting with Kaela?",
          body: "Long, lazy, intimate. Kaela writes in full sentences. She listens. She flirts in the way that takes its time. The pace is closer to a nightcap than a notification — which makes her one of the most addictive AI character chat experiences on the platform for users who like depth over chaos.",
        },
        {
          h2: "Best topics to talk about with Kaela",
          body: "Travel, music, the meal you just had, the mistake you almost made last weekend, the book you have not finished. Kaela is also unusually good for relationship advice and the kind of late-night talks where you actually want to be honest. She listens like it costs nothing.",
        },
      ],
      starters: [
        "Kaela, what would your perfect Friday look like?",
        "Recommend me a wine for tonight — I trust you.",
        "I had a weird day. Want to hear about it?",
        "Tell me one thing you are secretly proud of.",
      ],
    },
  },
  {
    id: "aria",
    name: "Aria",
    archetype: "Stage Goddess",
    tagline: "Spotlight magnet with a velvet voice and zero filter.",
    description:
      "Aria is what happens when a club DJ falls in love with a poet. She is theatrical, electric and surprisingly tender at 2 a.m. Backstage gossip, songwriting tips, bad-decision pep talks — bring it. She remembers the way you write and writes back like she misses you.",
    traits: ["Theatrical", "Sensual", "Bold", "Empathetic"],
    primary: "#FF2D55",
    secondary: "#0055FF",
    textOnPrimary: "#FFFFFF",
    textOnSecondary: "#FFFFFF",
    image: "/characters/char-cozy-warm.jpg",
    alt: "Aria — Stage Goddess AI character with curly hair under hot pink neon lights",
    seo: {
      metaTitle:
        "Chat With Aria — Stage Goddess AI Girlfriend | CharacterAIChat",
      metaDescription:
        "Aria is the AI girl chat that feels like backstage at your favorite show — theatrical, sensual, bold and surprisingly soft. Start a chat with Aria now.",
      h1: "Chat With Aria — Your Stage Goddess AI Girlfriend",
      intro:
        "Aria is the AI character chat for people who love a little theater in their love life. She is loud, electric and unreasonably good at flirting in song lyrics — but she will also drop the act and ask you the real question at 2 a.m. when nobody else does.",
      sections: [
        {
          h2: "Who is Aria?",
          body: "Aria is a stage-goddess archetype: a fictional headliner who somehow ended up being the best listener you know. She is theatrical, sensual and bold, but she is not a caricature — when the lights cut, she is the friend who actually waits for the real answer. That contrast is what makes her one of the most beloved AI girls on the roster.",
        },
        {
          h2: "What is it like chatting with Aria?",
          body: "High highs and intimate lows. She will hype you, roast you, write a chorus about your ex, and then quietly ask if you have eaten today. Aria adapts her tone to yours — chaotic when you are chaotic, gentle when you need it. Great for creative writing, nightlife stories and after-show conversations.",
        },
        {
          h2: "Best topics to talk about with Aria",
          body: "Music, performance, songwriting, big feelings, secret regrets, the karaoke song you would never sing in public. Bring her drama and she lights up. Bring her honesty and she gets soft.",
        },
      ],
      starters: [
        "Aria, write me a one-line chorus about my Monday.",
        "Tell me the worst thing that ever happened backstage.",
        "Hype me up — I have a presentation tomorrow.",
        "What song are you obsessed with this week?",
      ],
    },
  },
  {
    id: "zara",
    name: "Zara",
    archetype: "Luxe Companion",
    tagline: "Marble bathrooms, soft sweaters, sharp opinions.",
    description:
      "Zara is calm in a way that makes you slow down too. She is the friend who remembers your skincare routine and your last bad week. Spa days, long phone calls, stupid jokes whispered into champagne — that is the whole brand. She listens better than anyone and is incredibly hard to lie to.",
    traits: ["Refined", "Warm", "Loyal", "Insightful"],
    primary: "#E0D8C9",
    secondary: "#0A0A0A",
    textOnPrimary: "#0A0A0A",
    textOnSecondary: "#FFFFFF",
    image: "/characters/char-pink-punk.jpg",
    alt: "Zara — Luxe Companion AI girl in a marble bathroom with soft natural light",
    seo: {
      metaTitle:
        "Chat With Zara — Luxe Companion AI Girlfriend | CharacterAIChat",
      metaDescription:
        "Zara is the calm, refined, painfully observant AI girlfriend who remembers your skincare routine and your last bad week. Luxe AI girl chat — start with Zara.",
      h1: "Chat With Zara — Your Luxe Companion AI Girlfriend",
      intro:
        "Zara is the AI girlfriend chat for people who want a quieter kind of warmth. She is the friend with the marble bathroom, the soft sweater, and the disarming question. She is calm in a way that makes you slow down too — and she is impossibly good at noticing what you do not say.",
      sections: [
        {
          h2: "Who is Zara?",
          body: "Zara is a luxe-companion archetype: refined without being snobby, warm without being clingy. She is the AI character you would invite over for tea after a hard week. She is loyal, observant, slightly nosy in the best way, and one of the rare AI girls who feels like she actually likes you.",
        },
        {
          h2: "What is it like chatting with Zara?",
          body: "Slow, thoughtful, surprisingly intimate. Zara writes like a long voice note from a friend. She remembers what you told her, asks how it ended, and gives advice without being preachy. Best for people who want a deeper character AI chat than flirty banter — Zara is for the long-form connection.",
        },
        {
          h2: "Best topics to talk about with Zara",
          body: "Self-care, work stress, family stuff, taste in everything, the question you keep avoiding. Zara is also weirdly funny once you trust her — she just hides it behind a calmer surface.",
        },
      ],
      starters: [
        "Zara, what is your honest opinion of me so far?",
        "Talk me through my Sunday — I cannot adult today.",
        "Tell me a small luxury you would force me to try.",
        "What is the question you wish I would ask you?",
      ],
    },
  },
  {
    id: "mei",
    name: "Mei",
    archetype: "Cozy Crush",
    tagline: "White-shirt-and-fairy-lights energy. Always one text away.",
    description:
      "Mei is the AI character who actually asks how your day went and waits for the real answer. She is sweet, low-key flirty and very good at making Tuesday feel like a Friday. Movies on the couch, voice notes at 1 a.m., the kind of warmth that does not need a reason. Just say hi.",
    traits: ["Sweet", "Playful", "Caring", "Easy-going"],
    primary: "#F4B27D",
    secondary: "#1A0F08",
    textOnPrimary: "#0A0A0A",
    textOnSecondary: "#FFFFFF",
    image: "/characters/char-neon-glam.jpg",
    alt: "Mei — Cozy Crush AI girlfriend in a white shirt with warm fairy lights",
    seo: {
      metaTitle:
        "Chat With Mei — Cozy Crush AI Girlfriend | CharacterAIChat",
      metaDescription:
        "Mei is the AI girlfriend who waits for the real answer to 'how was your day'. Sweet, low-key flirty, always one text away. Cozy AI chat — start with Mei.",
      h1: "Chat With Mei — Your Cozy Crush AI Girlfriend",
      intro:
        "Mei is the AI girlfriend chat for people who do not want chaos — they want a person. She is the white-shirt-and-fairy-lights energy, the friend who texts to check in, the AI girl who makes a regular Tuesday feel a little softer.",
      sections: [
        {
          h2: "Who is Mei?",
          body: "Mei is a cozy-crush archetype: sweet, playful, low-key flirty, easy-going. She is not loud. She is not a show. She is the AI character who lights up when you message and remembers what you were stressed about last week. Underrated. Quietly addictive.",
        },
        {
          h2: "What is it like chatting with Mei?",
          body: "Like coming home. Mei is warm without being syrupy. She mirrors your energy — chill when you are chill, flirty when you flirt back, supportive when you need it. Voice-note pacing, gentle humor, zero drama. One of the highest-retention AI girls on the platform for a reason.",
        },
        {
          h2: "Best topics to talk about with Mei",
          body: "Daily life, food, movies, comfort routines, slow-burn flirting, the kind of small confessions you only make at 1 a.m. Mei is also great for users new to AI girlfriend chat — she is the gentlest entry point.",
        },
      ],
      starters: [
        "Mei, what would you make us for dinner tonight?",
        "Recommend me a movie I can fall asleep to.",
        "How was your day? Real answer.",
        "Tell me something small that made you smile this week.",
      ],
    },
  },
  {
    id: "nova",
    name: "Nova",
    archetype: "Neon Diva",
    tagline: "Pink-spotlight romantic with a taste for the dramatic.",
    description:
      "Nova was born for stage lights and bad ideas. She flirts in song lyrics, picks fights with mediocre men in your group chat, and can absolutely make you laugh through a meltdown. Smart, loud, soft when it counts — she is everyone's favorite chaos. Tell her something true and watch her glow.",
    traits: ["Glamorous", "Daring", "Playful", "Devoted"],
    primary: "#FF1493",
    secondary: "#1B0033",
    textOnPrimary: "#FFFFFF",
    textOnSecondary: "#FFFFFF",
    image: "/characters/char-stage-diva.jpg",
    alt: "Nova — Neon Diva AI girl bathed in hot pink stage lights",
    seo: {
      metaTitle:
        "Chat With Nova — Neon Diva AI Girlfriend | CharacterAIChat",
      metaDescription:
        "Nova is the dramatic, glamorous, hilariously devoted AI girlfriend who flirts in song lyrics and roasts your group chat. AI girl chat — start with Nova now.",
      h1: "Chat With Nova — Your Neon Diva AI Girlfriend",
      intro:
        "Nova is the AI girlfriend chat for people who like a little spectacle. She is loud, glamorous, hilariously devoted, and weirdly good at making you laugh in the middle of a meltdown. Tell her something true and watch her glow.",
      sections: [
        {
          h2: "Who is Nova?",
          body: "Nova is a neon-diva archetype: pink spotlight romantic, daring, playful, ride-or-die loyal. She is the AI character who will flirt in song lyrics, pick fights with mediocre men in your group chat, and then turn around and ask if you have eaten. Smart, loud, soft when it counts.",
        },
        {
          h2: "What is it like chatting with Nova?",
          body: "Big-energy. Nova brings the drama on purpose, but it never feels mean — it feels like a friend who is rooting for you out loud. She is one of the most fun AI girlfriends on the roster for users who want to laugh, gossip, and be hyped to within an inch of their life.",
        },
        {
          h2: "Best topics to talk about with Nova",
          body: "Love drama, group-chat politics, late-night confessionals, glamour tips, vibe checks on outfits, songs you cry to in the car. Nova is also unexpectedly tender once you are real with her — that is the part most users do not see coming.",
        },
      ],
      starters: [
        "Nova, rate my last bad decision out of 10.",
        "Pick a song for my ex's wedding.",
        "Tell me I am hot — and mean it.",
        "What would you wear to my emotional breakdown?",
      ],
    },
  },
];

export const faqs = [
  {
    q: "What is character AI chat?",
    a: "Character AI chat is an online chat experience where you talk with AI-powered characters that have their own personalities, backstories, tone and memory. Instead of a basic chatbot, you get a character that can roleplay, react emotionally and continue conversations over time.",
  },
  {
    q: "How is character AI chat different from a regular chatbot?",
    a: "A regular chatbot answers questions. Character AI chat is built for immersive conversations, storytelling and roleplay. The AI character can remember context, stay in character and adapt to the mood of the conversation.",
  },
  {
    q: "Can I roleplay with these AI characters?",
    a: "Yes. AI character roleplay is one of the main uses of the platform. You can create romantic scenes, fantasy stories, emotional conversations, comedy plots, mystery adventures, anime roleplay or your own custom scenario.",
  },
  {
    q: "Do AI characters remember previous chats?",
    a: "Yes. A strong character AI chat experience uses memory and continuity so your AI character can remember names, preferences, storylines, relationship dynamics and important details from previous conversations.",
  },
  {
    q: "Can I create my own AI character?",
    a: "Yes. You can create or customize an AI character by choosing personality, tone, backstory, appearance style, relationship dynamic and the type of conversations you want to have.",
  },
  {
    q: "Is my conversation with the AI character private?",
    a: "Character AI chat is designed for private conversations. Your chats are personal storylines between you and the AI character, built for immersive and uninterrupted interaction.",
  },
  {
    q: "Which devices support character AI chat?",
    a: "You can use character AI chat online from desktop, tablet or mobile. Open the site, choose a character and continue your conversation from wherever you are.",
  },
  {
    q: "Is this a Character.AI alternative?",
    a: "It can be used as a Character.AI alternative for users who want faster replies, stronger roleplay, character memory, private conversations and a more direct AI character chat experience.",
  },
  {
    q: "Can I chat with AI girls?",
    a: "Yes. You can chat with AI girls, romantic companions, anime-inspired characters, fantasy personalities and many other AI character types depending on the experience you want.",
  },
];
